import { ContentContainer, FormHeader } from '@snsw/react-component-library';
import React from 'react';

export const ProgressStepperLayout = (props) => {
  return (
    <>
      <FormHeader label={props.label} title={props.title} stepsList={props.stepsList} />

      <main id="sectionMain">
        <ContentContainer>{props.children}</ContentContainer>
      </main>
    </>
  );
};
